import { makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 40,
  },
});

const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();
  const src =
    theme.palette.type === 'dark'
      ? '/YCM-full-dark.png'
      : '/YCM-full-light.png';

  return <img className={classes.img} src={src} alt="YaCadMander" />;
};

export default LogoFull;
